module.exports = __webpack_public_path__ + "img/leg.7b44da7f.svg";